var $ = require('jquery');
var moment = require('moment');

var NewsFilter = function NewsFilter($blocks, $filters, $wrap) {
	this.types = ['date', 'tag', 'order'];
	this.options = {};
	this.$originals = $blocks;

	this.removeHyphens = function removeHyphens(className) {
		return (className.replace(/-/g, ''));
	}

	this.parseTags = function parseTags(tag) {
		var collection = [];

		var splitArray = tag.split('$$');

		$.map(splitArray, function(value) {
			if(value.length) {
				var keyVal = value.split('||');

				collection.push({
					key: keyVal[1],
					value: keyVal[0]
				});
			}
		});

		return collection;
	}

	this.findTypeFromClass = function findTypeFromClass(className) {
		return ($.inArray(className, this.types) > -1) ? true : false;
	}

	this.date = {
		getRange: function getRange($blocks) {
			var dates = $.map($blocks, function(block) {
				return moment($(block).attr('data-date')).format('MMM YYYY');
			});

			return $.unique(dates);
		},
		filter: function filter(dir) {

		}
	}

	this.tag = {
		getRange: function getRange($blocks) {
			var self = this;

			var tags = $.map($blocks, function(block) {
				var tags = $(block).attr('data-tag');

				if(tags.length) {
					return self.parseTags.call(self, tags);
				} else {
					return null;
				}
			});

			return tags;
		}
	}

	this.order = {
		getRange: function getRange() {
			return {
				'DESC': 'Newest First',
				'ASC': 'Oldest First'
			}
		}
	}

	this.handleFilter = function handleFilter($li, type) {
		if(typeof $li.attr('data-key') !== 'undefined') {
			if(type === 'date') {
				var date = $li.attr('data-key').split('-');
				this.options['filter[year]='] = date[0];
				this.options['filter[monthnum]='] = date[1];
			} else {
				this.options['filter[' + type + ']='] = $li.attr('data-key');
			}
		} else {
			if(type === 'date') {
				delete this.options['filter[year]='];
				delete this.options['filter[monthnum]='];
			} else {
				delete this.options['filter[' + type + ']='];
			}
		}
		
		var self = this;
		$.ajax(__CONFIG__.url + '/wp-json/wp/v2/posts/', {
			data: this.options,
			success: function(data) {
				var $elements = $();

				$blocks.remove();
				$.each(data, function(index, block) {
					$elements = $elements.add(self.$originals.filter('[data-id="' + block.id + '"]'));
				});

				if($elements.length > 0) {
					$wrap.append($elements);
				} else {
					$wrap.append('<h2 class="-dark">Sorry, there aren\'t any results for those filters');
				}
			}
		});

		$li.addClass('-active').siblings().removeClass('-active').end().parents('.dropdown').find('input[type="checkbox"]').prop('checked', false).siblings('.selected').find('.name b').text($li.text());
	}

	/** Loops over each dropdown and inits **/
	var self = this;
	$.each($filters.find('.dropdown'), function() {
		var $this = $(this);	

		var classesArray = $.map($(this).attr('class').split(' '), self.removeHyphens);
		var type = $.grep(classesArray, self.findTypeFromClass.bind(self))[0];

		var range = self[type].getRange.call(self, $blocks);
		var longestOption = {
			len: 0,
			value: ''
		}

		$.each(range, function(key, value) {
			if(!$this.find('.options ul li[data-key="' + key + '"]').length) {
				if(typeof value === 'object') {
					key = value.key;
					value = value.value;
				} else if(moment(new Date(value)).isValid()) {
					key = moment(new Date(value)).format('YYYY-MM');
				}

				if(value.length > longestOption.len) longestOption = {len: value.length, value: value};

				$this.find('.options ul').append(function() {
					return $('<li data-key="' + key + '">' + value + '</li>');
				});

				$this.find('.options li').click(function() {
					self.handleFilter($(this), type);
				});
			}
		});

		$this.find('.longest').text(longestOption.value);
	});
}

module.exports = NewsFilter;